import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Col, ControlLabel, Form, FormGroup} from 'react-bootstrap';
import {Field, reduxForm} from 'redux-form';
import {InputField} from './InputField';
import {RadioField} from './RadioField';

@reduxForm({form: 'FeedbackForExtraPops'})
export default class FeedbackForExtraPops extends Component {
    static propTypes = {
        handleSubmit: PropTypes.func, // passed by redux-form
        limit: PropTypes.number,
    };

    render() {
        const {handleSubmit} = this.props;
        return (
            <div>
                <Form onSubmit={handleSubmit} style={{margin: 'auto'}} className="feedback-for-extra-props">
                    <Col md={12} style={{marginBottom: 20}}>
                        <h4>{`Would you like to try another ${this.props.limit} pops for FREE?`}</h4>
                        {`Just fill in the boxes below to help us improve our product, and enter the email addresses of a couple of friends
                         or colleagues that you think might enjoy trying it out for free.
                         Then we'll charge up your account with another ${this.props.limit} pops (in the hopes that you will become permanently addicted!)`}
                    </Col>
                    <Field name="effectDescription" component={InputField} componentClass="textarea"
                           label="How would you describe the deep contrast image pop effect?" labelCol={{md: 12}} fieldCol={{md: 12}}/>
                    <FormGroup>
                        <Col md={12} style={{marginTop: 10}}>
                            <ControlLabel>{'For what purpose are you most likely to pop images?'}</ControlLabel>
                        </Col>
                        <Col md={12} style={{marginBottom: 20}}>
                            <Field type="radio" name="purpose" component={RadioField} value="Business" inline>
                                {'Business'}
                            </Field>
                            <Field type="radio" name="purpose" component={RadioField} value="Pleasure" inline>
                                {'Pleasure'}
                            </Field>
                            <Field type="radio" name="purpose" component={RadioField} value="Both" inline>
                                {'Both'}
                            </Field>
                        </Col>
                    </FormGroup>
                    <Field name="profession" component={InputField} type="text"
                           label="If for Business, how would you describe your profession?" labelCol={{md: 12}} fieldCol={{md: 12}}/>
                    <Field name="strengths" component={InputField} componentClass="textarea"
                           label="What do you like best about the deep contrast web app?" labelCol={{md: 12}} fieldCol={{md: 12}}/>
                    <Field name="needsImprovement" component={InputField} componentClass="textarea"
                           label="What improvements would you suggest to make our app more useful to you?" labelCol={{md: 12}} fieldCol={{md: 12}}/>
                    <Field name="references" component={InputField} componentClass="textarea"
                           label="Please list a few friends, family, or co-workers that might like to try popping images."
                           help={
                               <span>{`Enter their email addresses here, or have them send an email requesting their ${this.props.limit} free pops to `}<a
                                   href="mailto:support@deepcontrast.com">{'support@deepcontrast.com'}</a></span>}
                           labelCol={{md: 12}} fieldCol={{md: 12}}
                    />
                    <FormGroup>
                        <Col md={12} style={{textAlign: 'center'}}>
                            <Button type="submit" bsStyle="primary" className="registerBtn">{'SUBMIT'}</Button>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/FeedbackForExtraPops.js